export const DATA_MAP_RECORDS_PER_PAGE = 10;
export const INSERT_TYPE_TABLE = 'INSERT_TYPE_TABLE';
export const INSERT_TYPE_BULK_INSERT = 'INSERT_TYPE_BULK_INSERT';
export const INSERT_TYPE_FILE_UPLOAD = 'INSERT_TYPE_FILE_UPLOAD';
export const WRITE_MODE_APPEND = 'WRITE_MODE_APPEND';
export const WRITE_MODE_OVERWRITE = 'WRITE_MODE_OVERWRITE';
